<template>
    <button class="dark-mode-toggle" @click="toggleDarkMode">
        <span v-if="isDark">🌙</span>
        <span v-else>☀️</span>
        {{ isDark ? '深色' : '浅色' }}
    </button>
</template>

<script>
export default {
    name: 'DarkModeToggle',
    data() {
        return {
            isDark: false,
        };
    },
    created() {
        this.initTheme();
    },
    methods: {
        // 初始化主题：优先从 localStorage 读取，否则跟随系统
        initTheme() {
            const savedTheme = localStorage.getItem('theme');
            if (savedTheme) {
                this.isDark = savedTheme === 'dark';
            } else {
                // 检测系统深色模式偏好
                const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
                this.isDark = prefersDark;
            }
            this.applyTheme();
        },
        // 切换主题
        toggleDarkMode() {
            this.isDark = !this.isDark;
            this.applyTheme();
            localStorage.setItem('theme', this.isDark ? 'dark' : 'light');
        },
        // 应用主题：给 html 或 body 添加类名，同时更新 CSS 变量
        applyTheme() {
            const root = document.documentElement;
            if (this.isDark) {
                root.classList.add('dark');
                // 可以同时设置深色模式的 CSS 变量（见下方样式示例）
                root.style.setProperty('--bg-color', '#1e1e1e');
                root.style.setProperty('--text-color', '#f0f0f0');
            } else {
                root.classList.remove('dark');
                root.style.setProperty('--bg-color', '#ffffff');
                root.style.setProperty('--text-color', '#333333');
            }
        },
    },
};
</script>

<style scoped>
.dark-mode-toggle {
    font-size: 14px;
    padding: 8px 16px;
    border: 1px solid var(--border-color, #ccc);
    border-radius: 20px;
    background: var(--bg-color, #fff);
    color: var(--text-color, #333);
    cursor: pointer;
    transition: all 0.3s;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.dark-mode-toggle:hover {
    opacity: 0.8;
}
</style>